import { Link } from "@tanstack/react-router";
import { Phone } from "lucide-react";
import { SITE } from "@/lib/site";

export function StickyMobileCTA() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 grid grid-cols-2 gap-px border-t border-border bg-background shadow-[0_-4px_20px_-12px_rgba(0,0,0,0.25)] lg:hidden">
      <a
        href={SITE.phoneHref}
        className="flex items-center justify-center gap-2 py-3.5 text-sm font-medium text-primary"
      >
        <Phone className="h-4 w-4" /> Call Now
      </a>
      <Link
        to="/contact"
        className="flex items-center justify-center bg-primary py-3.5 text-sm font-medium text-primary-foreground"
      >
        Get a Free Quote
      </Link>
    </div>
  );
}